import styled from "styled-components";

export const ModalBody = styled.div`
  text-align: center;
`;

export const Icone = styled.div`
  margin: auto;
  font-size: 40px;

  svg {
    background-color: #e5fff8;
    color: #10ac85;
    border-radius: 10px;
    padding: 8px;
  }
`;

export const ContainerObservacao = styled.div`
  color: ${({ theme }) => theme.colors.neutral.neutral50};
  font-size: 14px;
  margin: 6px 0 16px 0;
`;

export const ContainerMensagem = styled.div`
  font-size: 16px;
  margin-top: 10px;
`;
